/* ============================================================
   nachin-benefits.js — Apertura y cierre suaves del acordeón de beneficios.

   POR QUÉ HACE FALTA JS: <details>/<summary> nativo NO anima. El navegador conmuta el
   atributo `open` y el contenido aparece o desaparece de golpe. Tampoco se puede
   transicionar `height` desde/hacia `auto` en CSS clásico.

   Se toma el control del clic: se mide la altura real del contenido y se anima con la
   Web Animations API. Se eligió esto —y no el CSS moderno de `::details-content` +
   `interpolate-size`— porque eso último es muy reciente y en los navegadores que no lo
   soportan la animación simplemente no ocurriría.

   JS SCOPEADO POR SECCIÓN (#NachinBenefits-<section.id>), con guard para no inicializar
   dos veces y re-init en `shopify:section:load` para que funcione dentro del editor.

   Accesibilidad: si el visitante pide menos movimiento (prefers-reduced-motion) no se
   intercepta el clic y queda el comportamiento nativo instantáneo.
   ============================================================ */
(function () {
  var DURACION = 320;
  var EASING = 'ease-in-out';

  function menosMovimiento() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  // Altura real del contenido, incluida en el cálculo la que aporta su interior.
  function altura(caja) {
    var previa = caja.style.height;
    caja.style.height = 'auto';
    var h = caja.offsetHeight;
    caja.style.height = previa;
    return h;
  }

  function animar(fila, caja, desde, hasta, opDesde, opHasta, alTerminar) {
    // Si ya había una animación corriendo (doble clic), se cancela y se arranca de nuevo:
    // así el acordeón siempre responde al último clic en vez de quedarse trabado.
    if (fila._anim) fila._anim.cancel();

    caja.style.overflow = 'hidden';
    var anim = caja.animate(
      [
        { height: desde + 'px', opacity: opDesde },
        { height: hasta + 'px', opacity: opHasta },
      ],
      // 🔴 `fill: forwards` NO es opcional. Sin él, al terminar la fase activa la Web
      // Animations API descarta los valores animados y el elemento vuelve por un fotograma
      // a su alto natural (medido: la altura saltaba de 5px a 186px con opacidad 1) antes
      // de que onfinish alcance a cerrarlo. Eso es un parpadeo visible al final de cada
      // cierre. Con forwards el último keyframe se mantiene hasta que limpiamos a mano.
      { duration: DURACION, easing: EASING, fill: 'forwards' }
    );
    fila._anim = anim;

    anim.onfinish = function () {
      fila._anim = null;
      // Primero el estado definitivo (cerrar el <details> si corresponde) y recién
      // después se suelta el fill y se limpian los estilos inline. Al revés vuelve el
      // parpadeo.
      if (alTerminar) alTerminar();
      anim.cancel();
      caja.style.height = '';
      caja.style.opacity = '';
      caja.style.overflow = '';
    };
  }

  function abrir(fila, caja) {
    fila.open = true; // hay que abrirlo para poder medir el contenido
    var h = altura(caja);
    animar(fila, caja, 0, h, 0, 1);
  }

  function cerrar(fila, caja) {
    var h = caja.offsetHeight || altura(caja);
    // la flecha vuelve a su posición desde el primer momento, no al final de la animación
    fila.classList.add('is-closing');
    animar(fila, caja, h, 0, 1, 0, function () {
      fila.open = false;
      fila.classList.remove('is-closing');
    });
  }

  function init(raiz) {
    if (!raiz || raiz.dataset.benefitsReady) return;
    raiz.dataset.benefitsReady = '1';

    raiz.querySelectorAll('.nachin-benefits__row').forEach(function (fila) {
      var cabeza = fila.querySelector('.nachin-benefits__head');
      var caja = fila.querySelector('.nachin-benefits__content');
      // Las filas sin contenido cargado se renderizan como <div> fijo, sin summary ni
      // contenido: no hay nada que animar.
      if (!cabeza || !caja || fila.tagName !== 'DETAILS') return;

      cabeza.addEventListener('click', function (evento) {
        if (menosMovimiento()) return;
        evento.preventDefault();
        if (fila.open && !fila.classList.contains('is-closing')) {
          cerrar(fila, caja);
        } else {
          fila.classList.remove('is-closing');
          abrir(fila, caja);
        }
      });
    });
  }

  function initTodas() {
    document.querySelectorAll('[data-nachin-benefits]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTodas);
  } else {
    initTodas();
  }

  // el editor de temas reemplaza el HTML de la sección al editarla
  document.addEventListener('shopify:section:load', function (evento) {
    var raiz = evento.target.querySelector('[data-nachin-benefits]');
    if (raiz) init(raiz);
  });
})();
